import { useApi } from './useApi';
import { useAppState } from './useAppState';
import { getHttpInstance, getApiConfig } from './useApi';
export function useSpending() {
    const api = useApi();
    const state = useAppState();
    function getSpendingPlansLite(onSuccess = null, refreshCache = false, clearCache = false) {
        const config = getApiConfig();
        const uri = config.api + (config.useCachedEndpoints ? '/Cached' : '') + "/Customers/00000000-0000-0000-0000-000000000000/Spending/Plans?lite=true";
        if (clearCache) {
            localStorage.removeItem(uri);
            return;
        }
        api.GET(uri, (result) => {
            state.spendingPlans = result;
            if (onSuccess)
                onSuccess();
        }, !refreshCache, refreshCache, /* ttlMins */ 3, /* retrying */ false, /* staleWhileRevalidate */ true);
    }
    function getSpendingPlansFull(onSuccess = null, refreshCache = false, clearCache = false, staleWhileRevalidate = true) {
        const config = getApiConfig();
        const uri = config.api + (config.useCachedEndpoints ? '/Cached' : '') + "/Customers/00000000-0000-0000-0000-000000000000/Spending/Plans?lite=false";
        if (clearCache) {
            localStorage.removeItem(uri);
            return;
        }
        api.GET(uri, (result) => {
            state.spendingPlansFull = result;
            if (onSuccess)
                onSuccess(console.log('Fetched full spending plans', result));
        }, !refreshCache, refreshCache, /* ttlMins */ 3, /* retrying */ false, staleWhileRevalidate);
    }
    function addSpendingPlan(plan, onSuccess = null) {
        getHttpInstance().post(getApiConfig().api + "/Customers/00000000-0000-0000-0000-000000000000/Spending/Plans", plan)
            .then((response) => { if (onSuccess)
            onSuccess(response.data); })
            .catch((result) => {
            if (result.response && result.response.status == 401) {
                api.refreshLogin(() => addSpendingPlan(plan, onSuccess));
            }
        });
    }
    function deleteSpendingPlan(id, onSuccess = null) {
        getHttpInstance().delete(getApiConfig().api + "/Customers/00000000-0000-0000-0000-000000000000/Spending/Plans/" + id)
            .then((response) => { if (onSuccess)
            onSuccess(response.data); })
            .catch((result) => {
            if (result.response && result.response.status == 401) {
                api.refreshLogin(() => deleteSpendingPlan(id, onSuccess));
            }
        });
    }
    function setupSpendingCycle(customerId, cycleId, day, autoAdjust, onSuccess = null) {
        const body = {
            id: "00000000-0000-0000-0000-000000000000",
            frequency: { id: cycleId, type: 0, workingDayBefore: autoAdjust, workingDayAfter: false },
            dayOfWeek: 0,
            day: day,
            month: 0
        };
        getHttpInstance().post(getApiConfig().api + "/Customers/00000000-0000-0000-0000-000000000000/Spending/Cycles", body)
            .then(() => { if (onSuccess)
            onSuccess(); })
            .catch((result) => {
            if (result.response && result.response.status == 401) {
                api.refreshLogin(() => setupSpendingCycle(customerId, cycleId, day, autoAdjust, onSuccess));
            }
        });
    }
    return {
        getSpendingPlansLite,
        getSpendingPlansFull,
        addSpendingPlan,
        deleteSpendingPlan,
        setupSpendingCycle,
    };
}
